import { $, w } from "./constants";
import { initUTMTracking } from "./utm";
import './crm-forms';

initUTMTracking();

w.load(() => {
  console.log("Hello world from El Cultivo! --Load");
});

$(document).ready(function () {
  console.log("Hello world from El Cultivo! --Ready");
  console.log("123 ");
});
